import React from 'react';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import { useHistory } from 'react-router-dom';
import { Image } from 'components/Image/Image';
import Label from 'components/form/Label/Label';

const InsuranceOfferCard = props => {
  const history = useHistory();
  const { tileIconKey, text, title, url, onLinkClickCallback } = props;

  const onClick = () => {
    onLinkClickCallback({ location: 'offers-insurance' });
    history.push(url);
  };

  return (
    <FlexContainer className={props.containerClasses}>
      <FlexContainer
        onClick={onClick}
        ariaLabel={`${title}`}
        tabIndex="0"
        role="region"
      >
        <FlexContainer className="flex-column padB20 padT10 padLR20">
          <FlexContainer className="FlexContainer flex-column">
            <FlexContainer>
              <Label
                className={
                  'system_neutral_n400_text text-18 m-text-16 bold margt20'
                }
                tabIndex="-1"
              >
                {title}
              </Label>
            </FlexContainer>
            <FlexContainer>
              <Label className="system_neutral_n400_text text-14 margt8">
                {text}
              </Label>
            </FlexContainer>
            <FlexContainer className="FlexContainer flex-column items-align-center margt12">
              <Image imgClass={tileIconKey} />
            </FlexContainer>
          </FlexContainer>
        </FlexContainer>
      </FlexContainer>
    </FlexContainer>
  );
};

export default InsuranceOfferCard;
